import * as FieldTypes from 'ContentUtils/constants/CustomWidgetFieldTypes';

// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'Cont... Remove this comment to see the full error message
import ChoiceField from 'ContentComponents/cmv2/fields/Choice';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'Cont... Remove this comment to see the full error message
import CTAField from 'ContentComponents/cmv2/fields/Cta';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'Cont... Remove this comment to see the full error message
import DateTimeField from 'ContentComponents/cmv2/fields/DateTime';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'Cont... Remove this comment to see the full error message
import EmailField from 'ContentComponents/cmv2/fields/Email';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'Cont... Remove this comment to see the full error message
import FileField from 'ContentComponents/cmv2/fields/File';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'Cont... Remove this comment to see the full error message
import HubDbField from 'ContentComponents/cmv2/fields/HubDb';
import NumberField from 'ContentComponents/cmv2/fields/Number';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'Cont... Remove this comment to see the full error message
import HtmlField from 'ContentComponents/cmv2/fields/Html';
import SimpleMenuField from 'ContentComponents/cmv2/fields/SimpleMenu';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'Cont... Remove this comment to see the full error message
import FormField from 'ContentComponents/cmv2/fields/Form';
import IconPickerField from 'ContentComponents/cmv2/fields/IconPicker';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'Cont... Remove this comment to see the full error message
import SalesforceCampaignField from 'ContentComponents/cmv2/fields/SalesforceCampaign';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'Cont... Remove this comment to see the full error message
import FollowupEmailField from 'ContentComponents/cmv2/fields/FollowupEmail';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'Cont... Remove this comment to see the full error message
import BlogField from 'ContentComponents/cmv2/fields/Blog';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'Cont... Remove this comment to see the full error message
import PageField from 'ContentComponents/cmv2/fields/PageSelect';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'Cont... Remove this comment to see the full error message
import FontPickerField from 'ContentComponents/cmv2/fields/FontPicker';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'Cont... Remove this comment to see the full error message
import MenuSelect from 'ContentComponents/cmv2/fields/MenuSelect';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'Cont... Remove this comment to see the full error message
import TagSelect from 'ContentComponents/cmv2/fields/TagSelect';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'Cont... Remove this comment to see the full error message
import WorkflowSelect from 'ContentComponents/cmv2/fields/WorkflowSelect';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'Cont... Remove this comment to see the full error message
import MeetingSelect from 'ContentComponents/cmv2/fields/MeetingSelect';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'Cont... Remove this comment to see the full error message
import Url from 'ContentComponents/cmv2/fields/Url';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'Cont... Remove this comment to see the full error message
import Link from 'ContentComponents/cmv2/fields/Link';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'Cont... Remove this comment to see the full error message
import Video from 'ContentComponents/cmv2/fields/Video';
import { CUSTOM_FIELD_TYPES } from 'knowledge-content-ui/constants/TemplateEditorConstants';
import BooleanField from './BooleanField';
import ColorPickerField from './ColorPickerField';
import ColorWithMobilePreviewField from './ColorWithMobilePreviewField';
import FieldGroup from './FieldGroup';
import HeaderBackgroundField from './HeaderBackgroundField';
import HeaderBackgroundPreviewField from './HeaderBackgroundPreviewField';
import ImageField from './ImageField';
import LogoField from './LogoField';
import ReadOnlyInput from './ReadOnlyInput';
import PlainTextField from './PlainTextField';
import SocialIconStyleField from './SocialIconStyleField';
import SocialLinksField from './SocialLinksField';
import SupportFormIdField from './SupportFormIdField';
import TemplateTypeField from './TemplateTypeField';
const BaseFields = {
  [FieldTypes.FILE]: FileField,
  [FieldTypes.HUBDB_TABLE]: HubDbField,
  [FieldTypes.CHOICE]: ChoiceField,
  [FieldTypes.NUMBER]: NumberField,
  [FieldTypes.CTA]: CTAField,
  [FieldTypes.PAGE]: PageField,
  [FieldTypes.FORM]: FormField,
  [FieldTypes.WORKFLOW]: WorkflowSelect,
  [FieldTypes.FOLLOW_UP_EMAIL]: FollowupEmailField,
  [FieldTypes.BLOG]: BlogField,
  [FieldTypes.MENU]: MenuSelect,
  [FieldTypes.TAG]: TagSelect,
  [FieldTypes.MEETING]: MeetingSelect,
  [FieldTypes.DATE]: DateTimeField,
  [FieldTypes.DATE_TIME]: DateTimeField,
  [FieldTypes.EMAIL]: EmailField,
  [FieldTypes.HUBL]: HtmlField,
  [FieldTypes.HTML]: HtmlField,
  [FieldTypes.SIMPLE_MENU]: SimpleMenuField,
  [FieldTypes.ICON]: IconPickerField,
  [FieldTypes.SFDC_CAMPAIGN]: SalesforceCampaignField,
  [FieldTypes.FONT]: FontPickerField,
  [FieldTypes.URL]: Url,
  [FieldTypes.LINK]: Link,
  [FieldTypes.VIDEO]: Video
};
const COMPONENTS_BY_TYPE = Object.assign({}, BaseFields, {
  [FieldTypes.TEXT]: PlainTextField,
  [FieldTypes.BOOLEAN]: BooleanField,
  [FieldTypes.COLOR]: ColorPickerField,
  [FieldTypes.GROUP]: FieldGroup,
  [FieldTypes.IMAGE]: ImageField,
  [CUSTOM_FIELD_TYPES.COLOR_WITH_MOBILE_PREVIEW]: ColorWithMobilePreviewField,
  [CUSTOM_FIELD_TYPES.HEADER_BACKGROUND]: HeaderBackgroundField,
  [CUSTOM_FIELD_TYPES.HEADER_BACKGROUND_PREVIEW]: HeaderBackgroundPreviewField,
  [CUSTOM_FIELD_TYPES.LOGO]: LogoField,
  [CUSTOM_FIELD_TYPES.READONLY_INPUT]: ReadOnlyInput,
  [CUSTOM_FIELD_TYPES.SOCIAL_ICON_STYLE]: SocialIconStyleField,
  [CUSTOM_FIELD_TYPES.SOCIAL_LINKS]: SocialLinksField,
  [CUSTOM_FIELD_TYPES.SUPPORT_FORM_ID]: SupportFormIdField,
  [CUSTOM_FIELD_TYPES.THEME_TYPE]: TemplateTypeField
});
export default COMPONENTS_BY_TYPE;